// extracted by mini-css-extract-plugin
export var bound = "round-module--bound--a20e4";
export var color_blue = "round-module--color_blue--e4f8e";
export var color_white = "round-module--color_white--8bc6e";
export var round = "round-module--round--bd5d7";